module.exports = __webpack_public_path__ + "static/media/poll.410651c8.png";